import { useMemo, useState } from 'react';

import axios, { endpoints } from 'src/utils/axios';

import { WorkspacesPopover } from 'src/layouts/components/workspaces-popover';

import { toast } from 'src/components/snackbar';

import { useAuthContext } from 'src/auth/hooks';

import { errorMessage } from './rado-ui';

// ----------------------------------------------------------------------

export function AccessContextWorkspaces(props) {
  const { user, checkUserSession } = useAuthContext();
  const [switching, setSwitching] = useState(false);

  const contexts = useMemo(
    () =>
      (user?.organizations || [])
        .filter((organization) => organization.status === 'Active' && organization.roles.length)
        .map((organization) => ({
          id: `organization-${organization.organizationId}`,
          mode: 'Organization',
          organizationId: organization.organizationId,
          name: organization.organizationName,
          description: (user?.globalRoles || []).length
            ? 'مجوزهای سازمانی و سراسری'
            : `مجوزهای تجمیع‌شده از ${organization.roles.length.toLocaleString('fa-IR')} نقش`,
          icon: 'solar:buildings-2-bold-duotone',
        })),
    [user?.globalRoles, user?.organizations]
  );

  const activeContext = contexts.find(
    (context) => context.organizationId === user?.activeContext?.organizationId
  );

  const handleSwitch = async (context) => {
    try {
      setSwitching(true);

      await axios.post(`${endpoints.organizations}/switch`, {
        organizationId: context.organizationId,
      });

      await checkUserSession?.();
      toast.success(`سازمان «${context.name}» فعال شد.`);
      return true;
    } catch (requestError) {
      toast.error(errorMessage(requestError));
      return false;
    } finally {
      setSwitching(false);
    }
  };

  if (!user || contexts.length <= 1) return null;

  return (
    <WorkspacesPopover
      data={contexts}
      value={activeContext?.id}
      onChange={handleSwitch}
      disabled={switching}
      tooltip="تغییر سازمان فعال"
      popoverTitle="انتخاب سازمان"
      popoverDescription="سازمان موردنظر خود را انتخاب کنید."
      secondaryFallback="مجوزهای تجمیع‌شده"
      aria-label="انتخاب سازمان فعال"
      {...props}
    />
  );
}
